import React from "react";

export default function SuccessModal({
  open,
  title,
  message,
  buttonText = "Continue",
  onClose,
  isError = false,
}) {
  if (!open) return null;

  return (
    <>
      <style>{`
        .success-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.55);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999999;
          padding: 20px;
          animation: fadeIn 0.2s ease;
          backdrop-filter: blur(4px);
        }

        .success-modal {
          width: 100%;
          max-width: 420px;
          background: white;
          border-radius: 24px;
          padding: 34px 28px;
          text-align: center;
          box-shadow:
            0 25px 60px rgba(0,0,0,0.25);
          animation: scaleIn 0.25s ease;
          font-family: 'Sora', sans-serif;
        }

        .success-icon {
          width: 82px;
          height: 82px;
          border-radius: 999px;
          background: ${
            isError
              ? "#fef2f2"
              : "#ecfdf3"
          };

          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 22px;
        }

        .success-check {
          font-size: 42px;

          color: ${
            isError
              ? "#dc2626"
              : "#16a34a"
          };

          font-weight: 700;
        }

        .success-title {
          font-size: 30px;
          font-weight: 700;
          color: #111827;
          margin-bottom: 12px;
          line-height: 1.2;
        }

        .success-message {
          font-size: 15px;
          line-height: 1.7;
          color: #6b7280;
          margin-bottom: 28px;
        }

        .success-btn {
          width: 100%;
          border: none;

          background: ${
            isError
              ? "#dc2626"
              : "#2d2b69"
          };

          color: white;
          padding: 14px;
          border-radius: 14px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .success-btn:hover {
          transform: translateY(-1px);

          background: ${
            isError
              ? "#b91c1c"
              : "#3c3a8f"
          };
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }

          to {
            opacity: 1;
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.92);
          }

          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @media (max-width: 480px) {
          .success-modal {
            padding: 28px 22px;
          }

          .success-title {
            font-size: 24px;
          }

          .success-message {
            font-size: 14px;
          }
        }
      `}</style>

      <div className="success-overlay">
        <div className="success-modal">

          <div className="success-icon">
            <div className="success-check">
              {isError ? "!" : "✓"}
            </div>
          </div>

          <div className="success-title">
            {title}
          </div>

          <div className="success-message">
            {message}
          </div>

          <button
            className="success-btn"
            onClick={onClose}
          >
            {buttonText}
          </button>

        </div>
      </div>
    </>
  );
}